var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';
export class BasicBridgeReportComponent {
    constructor(reportsApi, reportHelper, route, titleService) {
        this.reportsApi = reportsApi;
        this.reportHelper = reportHelper;
        this.route = route;
        this.error = false;
        this.errorMessage = this.reportHelper.reportErrorMessages.noReportData;
        this.isGenerating = false;
        titleService.setTitle(titleService.getTitle() + ' : Basic Bridge Report');
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isGenerating = true;
            this.route.paramMap.subscribe(x => {
                this.bridgeId = JSON.parse(window.localStorage.getItem(x.get('id'))).bridgeId;
                this.loadReport();
            });
        });
    }
    loadReport() {
        this.isGenerating = true;
        return this.reportsApi.getBridgeBasicReportData(parseInt(this.bridgeId, 10)).then((reportData) => {
            this.reportData = reportData;
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }
}
